import { mapState } from 'vuex';
import { analyticsEvent } from '~/plugins/analytics';
import formMixin from '../services/form';
import {
    email,
    max,
    min,
    required,
    requiredTrue,
} from '../services/validators';
import InlineRecaptcha from '~/components/form/InlineRecaptcha.vue';
import { setStorage } from '../services/storage';

export default {
    mixins: [formMixin],
    components: {
        InlineRecaptcha,
    },
    data() {
        return {
            email: '',
            mobile_number: '',
            first_name: '',
            password: '',
            recaptcha: '',
            sms_notifications: true,
            receive_emails: false,
            terms: false,
            org_token: this.$route.query.org_token,
            registerValidations: {
                email: [
                    email,
                    { validator: min, length: 5 },
                    { validator: max, length: 150 },
                    required,
                ],
                first_name: [
                    required,
                    { validator: max, length: 150 },
                ],
                mobile_number: [],
                password: [
                    required,
                    { validator: min, length: 5 },
                    { validator: max, length: 150 },
                ],
                sms_notifications: [],
                receive_emails: [],
                terms: [
                    { validator: requiredTrue, message: 'auth.please_accept_terms' },
                ],
            },
        };
    },
    computed: {
        ...mapState('auth', ['loggedIn']),
    },
    methods: {
        addUserValidations() {
            if (!this.loggedIn) {
                this.$form.replaceValidations(this.registerValidations);
            }
        },
        getUserValidations() {
            if (!this.loggedIn) {
                return this.registerValidations;
            }
            return {};
        },
        async registerUser(form = this.$form) {
            return new Promise((resolve) => {
                if (form.validateFields(['email', 'first_name', 'mobile_number', 'password', 'terms'])) {
                    if (this.loggedIn) {
                        resolve();
                        return;
                    }
                    form.submit(this.$config.endpoints.register, 'post', {
                        email: form.email.$model,
                        first_name: form.first_name.$model,
                        mobile_number: form.mobile_number.$model,
                        password: form.password.$model,
                        recaptcha: this.recaptcha,
                        subscribed: form.receive_emails.$model,
                        org_token: this.org_token,
                        ...(form.sms_notifications.$model === false && { sms_notifications: form.sms_notifications.$model }),
                    }, true).then(({ data }) => {
                        analyticsEvent('user', 'create', '1', '1');
                        setStorage('loginConverted', true);
                        this.$auth.setUserToken(data.token).then(() => {
                            resolve();
                        });
                    });
                }
            });
        },
        setRecaptcha(token) {
            this.recaptcha = token;
        },
    },
};
